export const dropDownObj = {
  daysOfWeek: [
    {displayText: 'Monday', value: 'MONDAY'},
    {displayText: 'Tuesday', value: 'TUESDAY'},
    {displayText: 'Wednesday', value: 'WEDNESDAY'},
    {displayText: 'Thursday', value: 'THURSDAY'},
    {displayText: 'Friday', value: 'FRIDAY'},
    {displayText: 'Saturday', value: 'SATURDAY'},
    {displayText: 'Sunday', value: 'SUNDAY'}
  ]
};
